import { TenantComponents } from 'types/Tenant';
import { MainFeaturesRoutesEnum, VevMainRoute } from '../types/vev-route';
import { Action, Entity } from '../types/Authorization';

export const SuperTenantRoutes: VevMainRoute[] = [
  {
    path: MainFeaturesRoutesEnum.TENANTS,
    loadChildren: async () => (await import('./../pages/tenants/tenants.module')).TenantsModule,
    data: {
      breadcrumb: 'general.menu.tenants',
      menu: {
        title: 'tenants',
        icon: 'account_balance',
        path: '/tenants',
      },
      auth: {
        entity: Entity.TENANT,
        action: Action.LIST,
      },
    },
  },
  {
    path: MainFeaturesRoutesEnum.FEATURE_TOGGLES,
    loadComponent: async () =>
      (await import('./../pages/feature-toggles/feature-toggles-list/feature-toggles-list.component'))
        .FeatureTogglesListComponent,
    data: {
      breadcrumb: 'general.menu.feature_toggles',
      menu: {
        title: 'feature_toggles',
        icon: 'add_task',
        path: '/feature-toggles',
      },
      auth: {
        entity: Entity.FEATURE_TOGGLES,
        action: Action.LIST,
      },
    },
  },
  {
    path: MainFeaturesRoutesEnum.TEMPLATES,
    loadChildren: async () =>
      (await import('./../pages/charging-station-templates/charging-station-templates.module'))
        .ChargingStationTemplatesModule,
    data: {
      breadcrumb: 'general.menu.charging_station_templates',
      menu: {
        title: 'charging_station_templates',
        icon: 'assignment',
        path: '/charging-station-templates',
      },
      auth: {
        entity: Entity.CHARGING_STATION_TEMPLATE,
        action: Action.LIST,
      },
      isAllowedInSuperTenantWhenInactive: true,
      displayInSuperTenant: true,
      hideFromNavbar: true,
    },
  },
  {
    path: MainFeaturesRoutesEnum.ROLES_MANAGEMENT,
    loadChildren: async () => (await import('../pages/roles-management/roles-management.module')).RolesManagementModule,
    data: {
      breadcrumb: 'roles_management.title',
      menu: {
        title: 'roles_management',
        icon: 'manage_accounts',
        path: '/roles-management',
      },
      auth: {
        entity: Entity.ROLES_MANAGEMENT,
        action: Action.READ,
      },
      isAllowedInSuperTenantWhenInactive: true,
      displayInSuperTenant: true,
      component: TenantComponents.ROLE_STATIC,
    },
  },
  {
    path: MainFeaturesRoutesEnum.REPORT_VIEW,
    loadChildren: async () => (await import('../pages/report-selection-view/reports.module')).ReportsModule,
    data: {
      breadcrumb: 'general.menu.analytics',
      menu: {
        title: 'analytics',
        icon: 'table_chart',
        path: '/report-view',
      },
      auth: {
        entity: Entity.POWER_BI,
        action: Action.LIST,
      },
      isAllowedInSuperTenantWhenInactive: true,
      displayInSuperTenant: true,
      hideFromNavbar: true,
    },
  },
  {
    path: MainFeaturesRoutesEnum.EVMODELS,
    loadChildren: async () => (await import('../pages/evmodels/evmodels.module')).EvModelsModule,
    data: {
      breadcrumb: 'general.menu.evmodels',
      menu: {
        title: 'evmodels',
        icon: 'directions_car',
        path: '/evmodels',
      },
      auth: { entity: Entity.EVMODEL, action: Action.LIST },
      isAllowedInSuperTenantWhenInactive: true,
      displayInSuperTenant: true,
      hideFromNavbar: true,
      component: TenantComponents.CAR,
    },
  },
];
